import React from "react";

export default function GuidalsHall() {
  return (
    <>
      <p class="c2">
        <span>
          <p>I told her stay, I begged her please,</p>
          <p>The threads are frail, the winds deceive.</p>
          <p>But bravery burns, it knows no chains,</p>
          <p>And now I stand with hollow pain.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>The wheel turns on, but something’s wrong,</p>
          <p>Her light is gone, my days feel long.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Alone I fight,</p>
          <p>The dream runs cold,</p>
          <p>The pattern weaves, but feels too old.</p>
          <p>She burned too bright, she flew too high,</p>
          <p>And left me here beneath the sky.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Her bow was drawn, her aim was true,</p>
          <p>Her courage shone like morning dew.</p>
          <p>But now the dream is torn apart,</p>
          <p>And all I feel is a broken heart.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>The wheel turns on, but something’s wrong,</p>
          <p>Her light is gone, my days feel long.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Alone I fight,</p>
          <p>The dream runs cold,</p>
          <p>The pattern weaves, but feels too old.</p>
          <p>She burned too bright, she flew too high,</p>
          <p>And left me here beneath the sky.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>I warned her once, I warned her twice,</p>
          <p>But still she paid the bitter price.</p>
          <p>Her strength was fierce, her heart was fire,</p>
          <p>And now I’m lost in my desire.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Alone I fight,</p>
          <p>The dream runs cold,</p>
          <p>The pattern weaves, but feels too old.</p>
          <p>She burned too bright, she flew too high,</p>
          <p>And left me here beneath the sky.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Through endless turns, the wheel will mend,</p>
          <p>But when, my love, will we meet again?</p>
          <p>Until that day, I’ll fight, I’ll roam,</p>
          <p>And carry you in my heart, my home.</p>
        </span>
      </p>
    </>
  );
}
